<template>
    <button ref="buttonRef" v-if="buttonMode == 'iconButton'"
        class="hrm_custom_icon_button hrm_button_hover buttongroup relative bg-hrmThemeBgColor text-hrmThemeTextColor rounded-lg"
        :style="{
            height: buttonSize,
            width: buttonSize,
            padding: buttonPadding,
            justifyContent: buttonAlign,
            alignItems: buttonAlign,
        }" :class="buttonClass" @mouseover="onHoverIn" @mouseout="onHoverOut">
        <slot>
            <span v-if="icon" class="hrm-button-icon-wrapper" :class="iconAnimClass">
                <Icon :class="animClass" :icon="icon" :width="iconSize" :height="iconSize" />
            </span>
        </slot>
        <teleport to="body">
            <span v-if="tooltipText && isShowToolTip" ref="tooltipRef" class="hrm_button_tooltip"
                :class="getTooltipPositionClass(tooltipPosition)">
                {{ tooltipText }}
            </span>
        </teleport>
    </button>
    <button ref="buttonRef" v-else-if="buttonMode == 'iconCompButton'"
        class="hrm_custom_icon_button hrm_button_hover buttongroup relative bg-hrmThemeBgColor text-hrmThemeTextColor rounded-lg"
        :style="{
            height: buttonSize,
            width: buttonSize,
            padding: buttonPadding,
            justifyContent: buttonAlign,
            alignItems: buttonAlign,
        }" :class="buttonClass" @mouseover="onHoverIn" @mouseout="onHoverOut">
        <slot>
            <span v-if="icon" class="hrm-button-icon-wrapper">
                <component :is="icon" />
            </span>
        </slot>
        <span v-if="tooltipText && isShowToolTip" class="hrm_button_tooltip"
            :class="getTooltipPositionClass(tooltipPosition)">
            {{ tooltipText }}
        </span>
    </button>
    <button ref="buttonRef" v-else-if="buttonMode == 'textButton'"
        class="hrm_custom_text_button hrm_button_hover group relative bg-hrmThemeBgColor text-hrmThemeTextColor rounded-lg text-xs font-semibold"
        :style="{
            height: buttonSize,
            padding: buttonPadding,
            justifyContent: buttonAlign,
            alignItems: buttonAlign,
        }" :class="buttonClass" @mouseover="onHoverIn" @mouseout="onHoverOut">
        <slot>
            {{ title }}
        </slot>
        <span v-if="tooltipText && isShowToolTip" class="hrm_button_tooltip"
            :class="getTooltipPositionClass(tooltipPosition)">
            {{ tooltipText }}
        </span>
    </button>
    <button ref="buttonRef" v-else-if="buttonMode == 'emojiButton'"
        class="hrm_custom_text_button hrm_button_hover group relative bg-hrmThemeBgColor text-hrmThemeTextColor rounded-lg font-semibold"
        :style="{
            height: buttonSize,
            width: buttonSize,
            padding: buttonPadding,
            justifyContent: buttonAlign,
            alignItems: buttonAlign,
        }" :class="buttonClass" @mouseover="onHoverIn" @mouseout="onHoverOut">
        <slot>
            <span v-if="icon" class="hrm-button-icon-wrapper">
                <Icon :class="animClass" :icon="icon" :width="iconSize" :height="iconSize" />
            </span>
        </slot>
        <span v-if="tooltipText && isShowToolTip" class="hrm_button_tooltip"
            :class="getTooltipPositionClass(tooltipPosition)">
            {{ tooltipText }}
        </span>
    </button>
    <button ref="buttonRef" v-else-if="buttonMode == 'iconTextButton'"
        class="hrm_custom_text_icon_button hrm_button_hover group relative bg-hrmThemeBgColor text-hrmThemeTextColor rounded-lg text-xs font-semibold"
        :style="{
            height: buttonSize,
            padding: buttonPadding,
            justifyContent: buttonAlign,
            alignItems: buttonAlign,
        }" :class="buttonClass" @mouseover="onHoverIn" @mouseout="onHoverOut">
        <slot>
            <span v-if="icon" class="hrm-button-icon-wrapper">
                <Icon :class="animClass" :icon="icon" :width="iconSize" :height="iconSize" />
            </span>
            {{ title }}
        </slot>
        <teleport to="body">
            <span v-if="tooltipText && isShowToolTip" ref="tooltipRef" class="hrm_button_tooltip"
                :class="getTooltipPositionClass(tooltipPosition)">
                {{ tooltipText }}
            </span>
        </teleport>
    </button>
    <button ref="buttonRef" v-else-if="buttonMode == 'progressButton'"
        class="hrm_custom_progress_button hrm_button_hover group relative bg-hrmThemeBgColor text-hrmThemeTextColor rounded-lg text-xs font-semibold"
        :style="{
            height: buttonSize,
            padding: buttonPadding,
            justifyContent: buttonAlign,
            alignItems: buttonAlign,
        }" :class="buttonClass" :disabled="loading" @mouseover="onHoverIn" @mouseout="onHoverOut">
        <slot>
            <span v-if="loading" class="mr-2 animate-spin flex items-center justify-center">
                <loading-icon :width="iconSize" :height="iconSize" />
            </span>
            {{ title }}
        </slot>
        <span v-if="tooltipText && isShowToolTip" class="hrm_button_tooltip"
            :class="getTooltipPositionClass(tooltipPosition)">
            {{ tooltipText }}
        </span>
    </button>
    <button ref="buttonRef" v-else-if="buttonMode == 'customButton'"
        class="hrm_custom_progress_button hrm_button_hover group relative bg-hrmThemeBgColor text-hrmThemeTextColor rounded-lg text-xs font-semibold"
        :style="{
            height: buttonSize,
            padding: buttonPadding,
            justifyContent: buttonAlign,
            alignItems: buttonAlign,
        }" :class="buttonClass" @mouseover="onHoverIn" @mouseout="onHoverOut">
        <slot name="customButton"></slot>
        <span v-if="tooltipText && isShowToolTip" class="hrm_button_tooltip"
            :class="getTooltipPositionClass(tooltipPosition)">
            {{ tooltipText }}
        </span>
    </button>

    <!-- Links -->
    <inertia-link ref="buttonRef" v-else-if="buttonMode == 'linkButton'"
        class="hrm_custom_text_button hrm_button_hover group relative bg-hrmThemeBgColor text-hrmThemeTextColor rounded-lg text-xs font-semibold"
        :style="{
            height: buttonSize,
            padding: buttonPadding,
            justifyContent: buttonAlign,
            alignItems: buttonAlign,
        }" :class="buttonClass" :href="link" @mouseover="onHoverIn" @mouseout="onHoverOut">
        <slot>
            {{ title }}
        </slot>
        <span v-if="tooltipText && isShowToolTip" class="hrm_button_tooltip"
            :class="getTooltipPositionClass(tooltipPosition)">
            {{ tooltipText }}
        </span>
    </inertia-link>

    <inertia-link ref="buttonRef" v-else-if="buttonMode == 'linkIconButton'"
        class="hrm_custom_text_button hrm_button_hover group relative bg-hrmThemeBgColor text-hrmThemeTextColor rounded-lg text-xs font-semibold"
        :style="{
            height: buttonSize,
            width: buttonSize,
            padding: buttonPadding,
            justifyContent: buttonAlign,
            alignItems: buttonAlign,
        }" :class="buttonClass" :href="link" @mouseover="onHoverIn" @mouseout="onHoverOut">
        <slot>
            <Icon :class="animClass" :icon="icon" :width="iconSize" :height="iconSize" />
        </slot>
        <span v-if="tooltipText && isShowToolTip" class="hrm_button_tooltip"
            :class="getTooltipPositionClass(tooltipPosition)">
            {{ tooltipText }}
        </span>
    </inertia-link>
    <inertia-link ref="buttonRef" v-else-if="buttonMode == 'linkIcontextButton'"
        class="hrm_custom_text_button hrm_button_hover group relative bg-hrmThemeBgColor text-hrmThemeTextColor rounded-lg text-xs font-semibold"
        :style="{
            height: buttonSize,
            width: buttonWidth,
            padding: buttonPadding,
            justifyContent: buttonAlign,
            alignItems: buttonAlign,
        }" :class="buttonClass" :href="link" @mouseover="onHoverIn" @mouseout="onHoverOut">
        <slot>
            {{ title }}
        </slot>
        <slot>
            <Icon :class="animClass" :icon="icon" :width="iconSize" :height="iconSize" />
        </slot>
        <span v-if="tooltipText && isShowToolTip" class="hrm_button_tooltip"
            :class="getTooltipPositionClass(tooltipPosition)">
            {{ tooltipText }}
        </span>
    </inertia-link>
    <a ref="buttonRef" v-else-if="buttonMode == 'linkButtonA'"
        class="hrm_custom_text_button hrm_button_hover group relative bg-hrmThemeBgColor text-hrmThemeTextColor rounded-lg text-xs font-semibold"
        :style="{
            height: buttonSize,
            padding: buttonPadding,
            justifyContent: buttonAlign,
            alignItems: buttonAlign,
        }" :class="buttonClass" :href="link" @mouseover="onHoverIn" @mouseout="onHoverOut">
        <slot>
            {{ title }}
        </slot>
        <span v-if="tooltipText && isShowToolTip" class="hrm_button_tooltip"
            :class="getTooltipPositionClass(tooltipPosition)">
            {{ tooltipText }}
        </span>
    </a>
    <a ref="buttonRef" v-else-if="buttonMode == 'linkIconButtonA'"
        class="hrm_custom_text_button hrm_button_hover group relative bg-hrmThemeBgColor text-hrmThemeTextColor rounded-lg text-xs font-semibold"
        :style="{
            height: buttonSize,
            width: buttonSize,
            padding: buttonPadding,
            justifyContent: buttonAlign,
            alignItems: buttonAlign,
        }" :class="buttonClass" :href="link" @mouseover="onHoverIn" @mouseout="onHoverOut">
        <slot>
            <Icon :class="animClass" :icon="icon" :width="iconSize" :height="iconSize" />
        </slot>
        <span v-if="tooltipText && isShowToolTip" class="hrm_button_tooltip"
            :class="getTooltipPositionClass(tooltipPosition)">
            {{ tooltipText }}
        </span>
    </a>
    <span ref="buttonRef" v-else-if="buttonMode == 'iconSpanButton'"
        class="cursor-pointer hrm_custom_icon_button hrm_button_hover buttongroup relative text-hrmThemeTextColor rounded-lg"
        :style="{
            height: buttonSize,
            width: buttonSize,
            padding: buttonPadding,
            justifyContent: buttonAlign,
            alignItems: buttonAlign,
        }" :class="buttonClass" @mouseover="onHoverIn" @mouseout="onHoverOut">
        <slot>
            <Icon :class="animClass" :icon="icon" :width="iconSize" :height="iconSize" />
        </slot>
        <span v-if="tooltipText && isShowToolTip" class="hrm_button_tooltip"
            :class="getTooltipPositionClass(tooltipPosition)">
            {{ tooltipText }}
        </span>
    </span>
    <span ref="buttonRef" v-else-if="buttonMode == 'spanButton'"
        class="cursor-pointer hrm_custom_icon_button hrm_button_hover buttongroup relative text-hrmThemeTextColor rounded-lg"
        :style="{
            height: buttonSize,
            width: buttonSize,
            padding: buttonPadding,
            justifyContent: buttonAlign,
            alignItems: buttonAlign,
        }" :class="buttonClass" @mouseover="onHoverIn" @mouseout="onHoverOut">
        <slot>
            <span v-html="title">
            </span>
        </slot>
        <span v-if="tooltipText && isShowToolTip" class="hrm_button_tooltip"
            :class="getTooltipPositionClass(tooltipPosition)">
            {{ tooltipText }}
        </span>
    </span>
    <label ref="buttonRef" v-else-if="buttonMode == 'fileUploadButton'" :for="uploadButtonId"
        class="cursor-pointer hrm_custom_icon_button hrm_button_hover buttongroup relative text-hrmThemeTextColor bg-hrmThemeBgColor rounded-lg"
        :style="{
            height: buttonSize,
            width: buttonSize,
            padding: buttonPadding,
            justifyContent: buttonAlign,
            alignItems: buttonAlign,
            fontSize: labelSize,
        }" :class="buttonClass" @mouseover="onHoverIn" @mouseout="onHoverOut">
        <slot>
            <span v-if="loading" class="mr-2 animate-spin flex items-center justify-center">
                <loading-icon />
            </span>
            <Icon v-else :class="animClass" :icon="icon" :width="iconSize" :height="iconSize" />
            {{ title }}
        </slot>
        <input :id="uploadButtonId" type="file" class="hidden" accept=".csv, .xlsx, .xls" @change="selectFile"
            :disabled="loading" />
        <span v-if="tooltipText && isShowToolTip" class="hrm_button_tooltip"
            :class="getTooltipPositionClass(tooltipPosition)">
            {{ tooltipText }}
        </span>
    </label>
</template>
<script setup lang="ts">
import { onMounted, ref, computed, onBeforeUnmount, watch, nextTick } from "vue";

import { Icon } from "@iconify/vue";
import LoadingIcon from "@/Common/LoadingIcon.vue";


import { createPopper, Instance } from '@popperjs/core'

const props = defineProps({
    buttonMode: {
        type: String,
        default: "iconButton",
    },
    title: {
        type: String,
        default: "",
    },
    icon: {
        type: String,
        default: "",
    },
    forName: {
        type: String,
        default: "",
    },
    buttonClass: {
        type: String,
        default: "",
    },
    loading: {
        type: Boolean,
        default: false,
    },
    iconSize: {
        type: String,
        default: "",
    },
    buttonSize: {
        type: String,
        default: "",
    },
    buttonWidth: {
        type: String,
        default: "",
    },
    buttonPadding: {
        type: String,
        default: "",
    },
    buttonAlign: {
        type: String,
        default: "",
    },
    tooltipText: {
        type: String,
        default: "",
    },
    tooltipPosition: {
        type: String,
        default: "top",
    },
    animClass: {
        type: String,
    },
    link: {
        type: String,
    },
    uploadButtonId: {
        type: String
    },
    iconAnimClass: {
        type: String
    },
    labelSize: {
        type: String
    }
})
const emits = defineEmits(['file'])

const isShowToolTip = ref(false)
const buttonRef = ref<HTMLElement | null>(null)
const tooltipRef = ref<HTMLElement | null>(null)
let popperInstance: Instance | null = null


const getTooltipPositionClass = (position) => {
    const positions = {
        left: "hrm_tooltip_left",
        right: "hrm_tooltip_right",
        top: "hrm_tooltip_top",
        bottom: "hrm_tooltip_bottom",
    };
    return positions[position] || "";
};

type Position = 'top' | 'bottom' | 'left' | 'right';
const tooltipPosition = ref<Position>(props.tooltipPosition as Position || 'top')
const tooltipText = ref<any>(props.tooltipText)

onMounted(() => {
    if (window.innerWidth < 768) {
        tooltipPosition.value = 'left';
        tooltipText.value = ''
    }
});

const onHoverIn = async () => {
    isShowToolTip.value = true;

    await nextTick(); // wait for tooltip to appear in DOM

    if (buttonRef.value && tooltipRef.value) {
        popperInstance = createPopper(buttonRef.value, tooltipRef.value, {
            placement: props.tooltipPosition as any,
            modifiers: [
                { name: "offset", options: { offset: [0, 8] } },
                { name: "preventOverflow", options: { boundary: "viewport" } },
                {
                    name: "updatePlacementClass",
                    enabled: true,
                    phase: "afterWrite",
                    fn({ state }) {
                        const basePlacement = state.placement.split('-')[0] as 'top' | 'bottom' | 'left' | 'right';
                        if (tooltipRef.value) {
                            tooltipRef.value.dataset.placement = basePlacement; // store it if needed
                            tooltipRef.value.classList.remove('hrm_tooltip_top', 'hrm_tooltip_bottom', 'hrm_tooltip_left', 'hrm_tooltip_right');
                            tooltipRef.value.classList.add(getTooltipPositionClass(basePlacement));
                        }
                    },
                },
            ],
        });
    }
};

const onHoverOut = () => {
    isShowToolTip.value = false;
    if (popperInstance) {
        popperInstance.destroy();
        popperInstance = null;
    }
};

const selectFile = (e) => {
    emits('file', e)
}


onBeforeUnmount(() => {
    if (popperInstance) popperInstance.destroy()
})
</script>
<style>
.hrm_custom_icon_button:hover,
.hrm_custom_text_button:hover,
.hrm_custom_text_icon_button:hover,
.hrm_custom_progress_button:hover {
    filter: brightness(120%);
}

.hrm_custom_progress_button svg path {
    fill: var(--hrm_Theme_Text_Color);
}

.hrm_button_hover:hover .hrm_button_tooltip {
    visibility: visible;
    opacity: 1;
}

.hrm_button_tooltip {
    position: absolute;
    /* visibility: hidden; */
    background-color: #2f3336;
    color: #fff;
    text-align: center;
    padding: 5px 10px;
    border-radius: 4px;
    white-space: nowrap;
    z-index: 9999999999;
    /* opacity: 0; */
    transition: opacity 0.3s !important;
    font-size: 12px;
    font-weight: 600;
    border-radius: 6px;
}

.hrm_button_tooltip::after {
    content: "";
    position: absolute;
    border-style: solid;
}

/* Bottom tooltip */
/* .hrm_tooltip_bottom {
    top: 130%;
    left: 50%;
    transform: translateX(-50%);
} */

.hrm_tooltip_bottom::after {
    top: -4px;
    left: 50%;
    transform: translate(-50%, -50%);
    border-width: 0 8px 8px 8px;
    border-color: transparent transparent #2f3336 transparent;
}

/* Top tooltip */
/* .hrm_tooltip_top {
    bottom: 130%;
    left: 50%;
    transform: translateX(-50%);
} */

.hrm_tooltip_top::after {
    bottom: -10px;
    left: 50%;
    transform: translate(-50%, -50%);
    border-width: 8px 8px 0 8px;
    border-color: #2f3336 transparent transparent transparent;
}

/* Left tooltip */
/* .hrm_tooltip_left {
    top: 50%;
    right: 126%;
    transform: translateY(-50%);
} */

.hrm_tooltip_left::after {
    top: 50%;
    right: -10px;
    transform: translate(-50%, -50%);
    border-width: 8px 0 8px 8px;
    border-color: transparent transparent transparent #2f3336;
}

/* Right tooltip */
/* .hrm_tooltip_right {
    top: 50%;
    left: 136%;
    transform: translateY(-50%);
} */

.hrm_tooltip_right::after {
    top: 50%;
    left: -4px;
    transform: translate(-50%, -50%);
    margin-top: 0;
    border-width: 8px 8px 8px 0;
    border-color: transparent #2f3336 transparent transparent;
}
</style>
